// imports
import { MouseEvent } from 'react';
import Link from 'next/link';
import { useAtom } from 'jotai';

// lib files
import { VideoClass } from '@/lib/types/api/video';
import {
  MyListConfirmModalTypeEnum,
  myListConfirmModalAtom
} from '@/lib/atoms/my-list-confirm-modal';

// components
import KabobMenu from '@/components/KabobMenu/KabobMenu';
import VideoThumbnail from '@/components/VideoThumbnail/VideoThumbnail';

// svgs
import PlayIcon from '@/public/svg/play.svg';
import ShowsIcon from '@/public/svg/shows.svg';
import MinusIcon from '@/public/svg/minus.svg';

// styles
import styles from './MyListVideoGridItem.module.scss';

interface MyListVideoGridItemProps {
  video: VideoClass;
}

const MyListVideoGridItem = (props: MyListVideoGridItemProps) => {
  const { video } = props;

  const { show, cid, slug, title } = video;

  const [ _, setConfirmModalState ] = useAtom(myListConfirmModalAtom);


  const handleRemoveClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const modalState = {
      id: cid,
      isOpen: true,
      slug: slug,
      title: title,
      type: MyListConfirmModalTypeEnum.VIDEO,
    }
    setConfirmModalState(modalState);
  }
  return (
    <div className={styles.my_list_video_grid_item}>
      <VideoThumbnail video={video} />
      <KabobMenu
        className={styles.my_list_video_kabob_menu}
        contentClassName={styles.my_list_video_kabob_menu_content}
      >
        <ul>
          <li>
            <Link href={`/video/${slug}/`} className={styles.my_list_video_link}>
              <PlayIcon />
              Watch Now
            </Link>
          </li>
        { show && (
          <li>
            <Link href={`/show/${show.slug}/`} className={styles.my_list_video_show_link}>
              <ShowsIcon />
              Explore the Show
            </Link>
          </li>
        )}
          <li>
            <button
              className={styles.my_list_video_remove_button}
              onClick={handleRemoveClick}>
              <MinusIcon />
              Remove from My List
            </button>
          </li>
        </ul>
      </KabobMenu>
    </div>
  );
};

export default MyListVideoGridItem;
